import React, { useState } from 'react';

const FAQ = () => {

  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
<div>
      {/* Prima sezione FAQ */}
      <section className="astronaut_section lg:pb-80 pb-30 pt-50 bg-[#fbfef5] min-h-[700px] bg-no-repeat bg-center bg-cover">
        <div className="container-xl mx-auto px-0 max-w-7xl">
          <h1 className="titolo-style mb-6 text-center">
              <span
                className="block text-[#131904]"
                style={{ marginBottom: '0px', display: 'block', fontSize: '55px', lineHeight: '1.2' }}
              >
                Hai qualche dubbio?
              </span>
              <span
                className="block text-[#94c41c]"
                style={{ marginTop: '0px', display: 'block', fontSize: '55px', lineHeight: '1.2' }}
              >
                Trova subito la risposta!
              </span>
            </h1>
          <div className="space-y-10 pl-10 pr-10 lg:pl-0 lg:pr-0">

            {/* FAQ 1 */}
            <div
              className="faq-item border-2 border-[#5e7a1f] rounded-lg p-4 cursor-pointer"
              onClick={() => toggleFAQ(0)}
              style={{
              borderRadius: '20px', // Applica la rotondità direttamente al div
            }}
            >
              <div className="flex justify-between items-center">
                <p className="text-left text-[#131904] text-2xl font-bold">
                  Cos'è un dominio?
                </p>
                <i
                className={`fas fa-chevron-down text-black font-bold transition-transform duration-300 transform ${
                  activeIndex === 0 ? 'rotate-180' : ''
                }`}
                style={{
                  fontSize: '17px', // Puoi aumentare o diminuire questa dimensione
                  transform: 'scale(1.3)', // Questo rende l'icona più cicciotta (maggiore dimensione)
                }}
              ></i>
              </div>
              {activeIndex === 0 && (
                <p className="mt-4 text-[#5e7a1f] text-left" style={{ fontSize: '20px' }}>
                  Per acquistare un dominio, basta cercarlo tramite il nostro motore di ricerca e seguire il processo di pagamento.
                </p>
              )}
            </div>

            {/* FAQ 2 */}
            <div
              className="faq-item border-2 border-[#5e7a1f] rounded-lg p-4 cursor-pointer"
              onClick={() => toggleFAQ(1)}
              style={{
              borderRadius: '20px', // Applica la rotondità direttamente al div
            }}
            >
              <div className="flex justify-between items-center">
                <p className="text-left text-[#131904] text-2xl font-bold">
                  A cosa serve un dominio?
                </p>
                <i
                className={`fas fa-chevron-down text-black font-bold transition-transform duration-300 transform ${
                  activeIndex === 1 ? 'rotate-180' : ''
                }`}
                style={{
                  fontSize: '17px', // Puoi aumentare o diminuire questa dimensione
                  transform: 'scale(1.3)', // Questo rende l'icona più cicciotta (maggiore dimensione)
                }}
              ></i>
              </div>
              {activeIndex === 1 && (
                <p className="mt-4 text-[#5e7a1f] text-left" style={{ fontSize: '20px' }}>
                  Un dominio serve come indirizzo univoco per un sito web, permettendo agli utenti di trovarlo facilmente su internet, senza dover ricordare un indirizzo IP numerico.
                </p>
              )}
            </div>

            {/* FAQ 3 */}
            <div
              className="faq-item border-2 border-[#5e7a1f] rounded-lg p-4 cursor-pointer"
              onClick={() => toggleFAQ(2)}
              style={{
              borderRadius: '20px', // Applica la rotondità direttamente al div
            }}
            >
              <div className="flex justify-between items-center">
                <p className="text-left text-[#131904] text-2xl font-bold">
                  Posso comprare un dominio anche se non ho un sito?
                </p>
                <i
                className={`fas fa-chevron-down text-black font-bold transition-transform duration-300 transform ${
                  activeIndex === 2 ? 'rotate-180' : ''
                }`}
                style={{
                  fontSize: '17px', // Puoi aumentare o diminuire questa dimensione
                  transform: 'scale(1.3)', // Questo rende l'icona più cicciotta (maggiore dimensione)
                }}
              ></i>
              </div>
              {activeIndex === 2 && (
                <p className="mt-4 text-[#5e7a1f] text-left" style={{ fontSize: '20px' }}>
                  Sì, puoi acquistare un dominio senza avere un sito. Puoi utilizzarlo in futuro o semplicemente per riservarlo.
                </p>
              )}
            </div>

            {/* FAQ 4 */}
            <div
              className="faq-item border-2 border-[#5e7a1f] rounded-lg p-4 cursor-pointer"
              onClick={() => toggleFAQ(3)}
              style={{
              borderRadius: '20px', // Applica la rotondità direttamente al div
            }}
            >
              <div className="flex justify-between items-center">
                <p className="text-left text-[#131904] text-2xl font-bold">
                  Cos’è un’estensione di dominio?
                </p>
                <i
                className={`fas fa-chevron-down text-black font-bold transition-transform duration-300 transform ${
                  activeIndex === 3 ? 'rotate-180' : ''
                }`}
                style={{
                  fontSize: '17px', // Puoi aumentare o diminuire questa dimensione
                  transform: 'scale(1.3)', // Questo rende l'icona più cicciotta (maggiore dimensione)
                }}
              ></i>
              </div>
              {activeIndex === 3 && (
                <p className="mt-4 text-[#5e7a1f] text-left" style={{ fontSize: '20px' }}>
                  L'estensione di un dominio (come .com, .it, .org) indica la categoria o il paese di appartenenza del sito, aggiungendo una parte distintiva all'indirizzo.
                </p>
              )}
            </div>

            {/* FAQ 5 */}
            <div
              className="faq-item border-2 border-[#5e7a1f] rounded-lg p-4 cursor-pointer"
              onClick={() => toggleFAQ(4)}
              style={{
              borderRadius: '20px', // Applica la rotondità direttamente al div
            }}
            >
              <div className="flex justify-between items-center">
                <p className="text-left text-[#131904] text-2xl font-bold">
                  Come faccio a sapere se un dominio è disponibile?
                </p>
                <i
                className={`fas fa-chevron-down text-black font-bold transition-transform duration-300 transform ${
                  activeIndex === 4 ? 'rotate-180' : ''
                }`}
                style={{
                  fontSize: '17px', // Puoi aumentare o diminuire questa dimensione
                  transform: 'scale(1.3)', // Questo rende l'icona più cicciotta (maggiore dimensione)
                }}
              ></i>
              </div>
              {activeIndex === 4 && (
                <p className="mt-4 text-[#5e7a1f] text-left" style={{ fontSize: '20px' }}>
                  Puoi verificare la disponibilità di un dominio utilizzando strumenti online di ricerca dominio, come quelli offerti da registrar di domini.
                </p>
              )}
            </div>

            {/* FAQ 6 */}
            <div
              className="faq-item border-2 border-[#5e7a1f] rounded-lg p-4 cursor-pointer"
              onClick={() => toggleFAQ(5)}
              style={{
              borderRadius: '20px', // Applica la rotondità direttamente al div
            }}
            >
              <div className="flex justify-between items-center">
                <p className="text-left text-[#131904] text-2xl font-bold">
                  Cosa succede dopo aver acquistato un dominio?
                </p>
                <i
                className={`fas fa-chevron-down text-black font-bold transition-transform duration-300 transform ${
                  activeIndex === 5 ? 'rotate-180' : ''
                }`}
                style={{
                  fontSize: '17px', // Puoi aumentare o diminuire questa dimensione
                  transform: 'scale(1.3)', // Questo rende l'icona più cicciotta (maggiore dimensione)
                }}
              ></i>
              </div>
              {activeIndex === 5 && (
                <p className="mt-4 text-[#5e7a1f] text-left" style={{ fontSize: '20px' }}>
                  Dopo l'acquisto, il dominio è registrato a tuo nome. Puoi associarlo a un sito web, configurarvi email o semplicemente mantenerlo.
                </p>
              )}
            </div>

            {/* FAQ 7 */}
            <div
              className="faq-item border-2 border-[#5e7a1f] rounded-lg p-4 cursor-pointer"
              onClick={() => toggleFAQ(6)}
              style={{
              borderRadius: '20px', // Applica la rotondità direttamente al div
            }}
            >
              <div className="flex justify-between items-center">
                <p className="text-left text-[#131904] text-2xl font-bold">
                  Per quanto tempo è valido un dominio?
                </p>
                <i
                className={`fas fa-chevron-down text-black font-bold transition-transform duration-300 transform ${
                  activeIndex === 6 ? 'rotate-180' : ''
                }`}
                style={{
                  fontSize: '17px', // Puoi aumentare o diminuire questa dimensione
                  transform: 'scale(1.3)', // Questo rende l'icona più cicciotta (maggiore dimensione)
                }}
              ></i>
              </div>
              {activeIndex === 6 && (
                <p className="mt-4 text-[#5e7a1f] text-left" style={{ fontSize: '20px' }}>
                  Un dominio è valido per un anno dal momento dell'acquisto, ma puoi rinnovarlo per periodi più lunghi.
                </p>
              )}
            </div>

            {/* FAQ 8 */}
            <div
              className="faq-item border-2 border-[#5e7a1f] rounded-lg p-4 cursor-pointer"
              onClick={() => toggleFAQ(7)}
              style={{
              borderRadius: '20px', // Applica la rotondità direttamente al div
            }}
            >
              <div className="flex justify-between items-center">
                <p className="text-left text-[#131904] text-2xl font-bold">
                  Cosa succede se non rinnovo il mio dominio?
                </p>
                <i
                className={`fas fa-chevron-down text-black font-bold transition-transform duration-300 transform ${
                  activeIndex === 7 ? 'rotate-180' : ''
                }`}
                style={{
                  fontSize: '17px', // Puoi aumentare o diminuire questa dimensione
                  transform: 'scale(1.3)', // Questo rende l'icona più cicciotta (maggiore dimensione)
                }}
              ></i>
              </div>
              {activeIndex === 7 && (
                <p className="mt-4 text-[#5e7a1f] text-left" style={{ fontSize: '20px' }}>
                  Se non rinnovi il dominio, esso scadrà e potrà essere acquistato da qualcun altro, perdendo l'accesso al tuo sito o ai tuoi servizi associati.
                </p>
              )}
            </div>

            {/* FAQ 9 */}
            <div
              className="faq-item border-2 border-[#5e7a1f] rounded-lg p-4 cursor-pointer"
              onClick={() => toggleFAQ(8)}
              style={{
              borderRadius: '20px', // Applica la rotondità direttamente al div
            }}
            >
              <div className="flex justify-between items-center">
                <p className="text-left text-[#131904] text-2xl font-bold">
                  Come si rinnova un dominio su Seeurl?
                </p>
                <i
                className={`fas fa-chevron-down text-black font-bold transition-transform duration-300 transform ${
                  activeIndex === 8 ? 'rotate-180' : ''
                }`}
                style={{
                  fontSize: '17px', // Puoi aumentare o diminuire questa dimensione
                  transform: 'scale(1.3)', // Questo rende l'icona più cicciotta (maggiore dimensione)
                }}
              ></i>
              </div>
              {activeIndex === 8 && (
                <p className="mt-4 text-[#5e7a1f] text-left" style={{ fontSize: '20px' }}>
                  Puoi rinnovare un dominio su Seeurl accedendo al tuo account e selezionando l'opzione di rinnovo per estendere la sua validità.
                </p>
              )}
            </div>

            {/* FAQ 10 */}
            <div
              className="faq-item border-2 border-[#5e7a1f] rounded-lg p-4 cursor-pointer"
              onClick={() => toggleFAQ(9)}
              style={{
              borderRadius: '20px', // Applica la rotondità direttamente al div
            }}
            >
              <div className="flex justify-between items-center">
                <p className="text-left text-[#131904] text-2xl font-bold">
                  Posso cambiare il nome del mio dominio dopo l’acquisto?
                </p>
                <i
                className={`fas fa-chevron-down text-black font-bold transition-transform duration-300 transform ${
                  activeIndex === 9 ? 'rotate-180' : ''
                }`}
                style={{
                  fontSize: '17px', // Puoi aumentare o diminuire questa dimensione
                  transform: 'scale(1.3)', // Questo rende l'icona più cicciotta (maggiore dimensione)
                }}
              ></i>
              </div>
              {activeIndex === 9 && (
                <p className="mt-4 text-[#5e7a1f] text-left" style={{ fontSize: '20px' }}>
                  No, non è possibile cambiare il nome di un dominio una volta acquistato. Dovresti acquistare un nuovo dominio se desideri un nome diverso.
                </p>
              )}
            </div>

            {/* FAQ 10 */}
            <div
              className="faq-item border-2 border-[#5e7a1f] rounded-lg p-4 cursor-pointer"
              onClick={() => toggleFAQ(10)}
              style={{
              borderRadius: '20px', // Applica la rotondità direttamente al div
            }}
            >
              <div className="flex justify-between items-center">
                <p className="text-left text-[#131904] text-2xl font-bold">
                  Cos’e il DNS e a cosa serve?
                </p>
                <i
                className={`fas fa-chevron-down text-black font-bold transition-transform duration-300 transform ${
                  activeIndex === 10 ? 'rotate-180' : ''
                }`}
                style={{
                  fontSize: '17px', // Puoi aumentare o diminuire questa dimensione
                  transform: 'scale(1.3)', // Questo rende l'icona più cicciotta (maggiore dimensione)
                }}
              ></i>
              </div>
              {activeIndex === 10 && (
                <p className="mt-4 text-[#5e7a1f] text-left" style={{ fontSize: '20px' }}>
                  Il DNS (Domain Name System) è un sistema che traduce i nomi di dominio in indirizzi IP, consentendo ai browser di trovare i siti web correttamente.
                </p>
              )}
            </div>

          </div>
        </div>
      </section>

      {/* Separatore ondulato tra le due parti */}
      <div className="relative bg-[#fbfef5] mt-10">
        <div className="absolute bottom-0 left-0 w-full z-10">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1200 120"
            height="120"
            width="100%"
            preserveAspectRatio="none"
            className="block w-full h-full"
          >
            <path
              fill="#f3f9e4"
              d="M0,60 C650,-100 800,180 1200,60 L1200,120 L0,120 Z"
            />
          </svg>
        </div>
      </div>

      {/* Seconda sezione con immagine undraw_contact-us.svg */}
      <section className="astronaut_section pb-40 pt-0 bg-[#f3f9e4] min-h-[800px] bg-no-repeat bg-center bg-cover">
        <div className="container-xl mx-auto px-0 flex justify-between items-center max-w-7xl max-w-[85%] gap-15 flex-col lg:flex-row">
          
          {/* Left side (Image) */}
          <div className="w-full lg:w-1/2 mb-8 lg:mb-0">
            <img
              src="/static/immagine_contatti_2.svg"
              alt="Digital Domain"
              className="max-w-full h-auto"
            />
          </div>

          {/* Right side (Text) */}
          <div className="w-full lg:w-1/2 text-lg">
            <h2 className="titolo-style mb-6 text-left">
              <span
                className="block text-[#131904]"
                style={{ marginBottom: '0px', display: 'block', fontSize: '55px', lineHeight: '1' }}
              >
                Hai ancora dei dubbi?
              </span>
              <span
                className="block text-[#94c41c]"
                style={{ marginTop: '0px', display: 'block', fontSize: '55px', lineHeight: '1' }}
              >
                Contattaci
              </span>
            </h2>

            {/* Description Text */}
            <p className="regular-text text-left text-[#131904] max-w-full mx-auto block" style={{ fontSize: '25px' }}>
              Il nostro team di supporto è sempre a tua disposizione.
            </p>

            {/* Icons and Titles */}
            <div className="mt-12 space-y-8">
              {/* Icon 1 - Email */}
              <div className="flex flex-col items-start mb-6">
                {/* Contenuto icon + titolo */}
                <div className="flex items-center mb-2">
                  <i className="fas fa-2x fa-envelope text-[#131904]"></i>
                  <span className="font-bold text-[#131904] ml-4" style={{ fontSize: '23px' }}>Email</span>
                </div>

                {/* Paragrafo sotto il titolo */}
                <p className="regular-text text-left text-[#131904]" style={{ fontSize: '22px' }}>
                  info@seeurl.it
                </p>
              </div>

              {/* Icon 2 - Phone */}
              <div className="flex flex-col items-start mb-6">
                {/* Contenuto icon + titolo */}
                <div className="flex items-center mb-2">
                  <i className="fas fa-2x fa-phone-alt text-[#131904]"></i>
                  <span className="font-bold text-[#131904] ml-4" style={{ fontSize: '23px' }}>Telefono</span>
                </div>

                {/* Paragrafo sotto il titolo */}
                <p className="regular-text text-left text-[#131904]" style={{ fontSize: '22px' }}>
                  +39 0734 2787
                </p>
              </div>

              {/* Icon 3 - Location */}
              <div className="flex flex-col items-start mb-6">
                {/* Contenuto icon + titolo */}
                <div className="flex items-center mb-2">
                  <i className="fas fa-2x fa-map-marker-alt text-[#131904]"></i>
                  <span className="font-bold text-[#131904] ml-4" style={{ fontSize: '23px' }}>Posizione</span>
                </div>

                {/* Paragrafo sotto il titolo */}
                <p className="regular-text text-left text-[#131904]" style={{ fontSize: '22px' }}>
                  Via Antonio Meucci 1, Porto San Giorgio (FM) 63822 Italia
                </p>
              </div>

              {/* Icon 4 - Pin */}
              <div className="flex flex-col items-start mb-6">
                {/* Contenuto icon + titolo */}
                <div className="flex items-center mb-2">
                  <i className="fas fa-2x fa-map-marker-alt text-[#131904]"></i>
                  <span className="font-bold text-[#131904] ml-4" style={{ fontSize: '23px' }}>Posizione</span>
                </div>

                {/* Paragrafo sotto il titolo */}
                <p className="regular-text text-left text-[#131904]" style={{ fontSize: '22px' }}>
                  Via Caldera 21 - Palazzo F, Milano (MI) 20153 Italia
                </p>
              </div>
            </div>
          </div>
        </div>
</section>

{/* Sezione Richiamo Compra Dominio */}
<section className="bg-[#95c11f] text-center py-20 pt-40 pb-40">
    <div className="container-xl mx-auto px-6 max-w-3xl max-w-[85%]">
      {/* Titolo con doppia riga e doppio colore */}
      <h2 className="titolo-style text-center text-5xl text-black mb-6">
        <span className="block text-[#131904]" style={{ marginBottom: '10px', display: 'block', fontSize: '55px' }}>
          Cerca, trova, acquista.
        </span>
        <span className="block text-[#fbfef5]" style={{ marginTop: '10px', display: 'block', fontSize: '55px' }}>
          Ottieni il dominio perfetto!
        </span>
      </h2>

      {/* Search Form */}
      <div className="mt-12 flex justify-center">
        <form
          action="../search-results"
          acceptCharset="UTF-8"
          method="get"
          className="w-full max-w-[100%] sm:max-w-[70%] md:max-w-[50%] lg:max-w-[40%] xl:max-w-[35%]"
        >
          <div
            className="relative flex overflow-hidden h-18 border-2 bg-[#fbfef5]"
            style={{
              borderRadius: '20px', // Applica la rotondità direttamente al div
            }}
          >
            <input
              type="text"
              name="terms"
              id="terms"
              placeholder="Cerca qui il tuo dominio ideale..."
              className="flex-grow px-6 py-4 text-xl text-[#4b6f32] focus:outline-none h-full placeholder-white"
              style={{ fontSize: '18px', color: '#869d4a' }}
            />
            <button
              type="submit"
              style={{
                color: '#869d4a',
                padding: '0px 20px',
                borderTopLeftRadius: '0',
                borderBottomLeftRadius: '0',
                borderTopRightRadius: '20px',
                borderBottomRightRadius: '20px',
                border: 'none',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'background-color 0.3s',
              }}
            >
              <svg
                style={{ width: '35px', height: '35px' }}
                fill="none"
                stroke="#869d4a"
                strokeWidth="1.5"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="11" cy="11" r="7" strokeLinecap="round" strokeLinejoin="round" />
                <line x1="21" y1="21" x2="16.65" y2="16.65" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
          </div>
        </form>
      </div>
    </div>
  </section>
    </div>
  );
};

export default FAQ;
